import { render } from "./AddTeam.vue?vue&type=template&id=025c2874"
import script from "./AddTeam.vue?vue&type=script&lang=js"
export * from "./AddTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__